import { Col, Row } from "react-bootstrap";
import TabContainerWithTabs from "../components/TabContainer";
import RebalanceActionButtons from "./RebalanceActionButtons";
import RebalancesNav from "./RebalancesNav";
import RebalancesExecutedTodayTable from "./RebalancesExecutedTodayTable";

const RebalancesExecuted = ({
  householdId,
  canPerformAction,
}: {
  householdId?: string;
  canPerformAction?: boolean;
}) => {
  return (
    <>
      <Row>
        <Col>
          <RebalanceActionButtons />
        </Col>
      </Row>
      <TabContainerWithTabs tabs={RebalancesNav}>
        <RebalancesExecutedTodayTable />
      </TabContainerWithTabs>
    </>
  );
};

export default RebalancesExecuted;
